import { miQsWeatherDomains } from "@/constants/domain.config";
import { getCurrentAdScenario } from "@/hooks/useAdScenario";
import useTranslate from "@/hooks/useTranslate";
import { pxChangeVw } from "@/utils";
import { getPrivacyPolicyUrl } from "@/utils/copyright";
import { getMainDomain } from "@/utils/getMainDomain";

const footerAttributionHiddenHosts = ["www.comfortweather.com"];

function shouldHideFooterAttribution(hostName: string, isTranTabAdScenario: boolean) {
  // 页脚 AccuWeather 归因只按精确 host 隐藏，避免改动广告域名分组时误伤其他域名。
  return (
    [...domainMap["v-ls"], ...domainMap["mils"], ...miQsWeatherDomains, ...footerAttributionHiddenHosts].includes(
      hostName
    ) || isTranTabAdScenario
  );
}

export default function PrivacyAgree({}) {
  const style01: any = {
    // width: "16rem",
    width: pxChangeVw(224),
    display: "flex",
    textAlign: "center",
    fontSize: "10px",
    // lineHeight: "0.7rem",
    lineHeight: pxChangeVw(10),
  };
  const style02: any = {
    margin: "0 auto",
    lineHeight: "16px",
  };
  const style03 = {
    textDecoration: "underline",
    color: "var(--app-text-04)",
  };
  const textStyle = {
    fontSize: "12px",
  };
  const { $t } = useTranslate();
  const { isTranTabAdScenario } = getCurrentAdScenario();

  const domainTitleMap: any = {
    "24hweather.com": $t("title50"),
    "mobi321.com": $t("title60"),
    default: $t("title40"),
  };
  const { hostName } = useHostName();
  const hideFooterAttribution = shouldHideFooterAttribution(hostName, isTranTabAdScenario);
  return (
    <div className="flex flex-col gap-y-20 mt-30 app-privacy-policy">
      {hideFooterAttribution ? null : (
        <div className="color-[var(--app-text-04)] center gap-x-4">
          <div className="font-400 color-[var(--app-text-15)]" style={textStyle}>
            {$t("title41")}
          </div>
          <div className="flex justify-start items-center">
            <SvgIcon className="w-80! h-12!" name={"svg14"} />
          </div>
          <div className="font-400 color-[var(--app-text-15)]" style={textStyle}>
            {$t("title48")}
          </div>
        </div>
      )}

      <div className="flex flex-col color-[var(--app-text-04)] justify-start items-center m-[10px_0]">
        <div style={style01}>
          <p style={{ ...style02, ...textStyle }}>
            {getMainDomain() === "24hweather.com" ? $t("title49") : $t("title38")}
          </p>
        </div>
        <div style={style01}>
          <p style={style02}>
            <a href={getPrivacyPolicyUrl()} target="_blank" style={{ ...textStyle, ...style03 }}>
              {$t("title39")}
            </a>
          </p>
        </div>
        <div style={style01}>
          <p style={{ ...textStyle, ...style02 }}>{domainTitleMap[getMainDomain()] ?? domainTitleMap["default"]}</p>
        </div>
      </div>
    </div>
  );
}
